import { useEffect, useState } from "react";
import { BellRing, ChevronRight } from "lucide-react";
import { enableWebPush, webPushStatus } from "../lib/pushClient";
import { useI18n } from "../lib/i18n";

export default function PlayerPushOptInNotice() {
  const { t } = useI18n();
  const [status, setStatus] = useState("loading");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let active = true;
    webPushStatus().then((result) => {
      if (active) setStatus(result.status);
    }).catch(() => {
      if (active) setStatus("error");
    });
    return () => { active = false; };
  }, []);

  if (status !== "inactive") return null;
  const enable = async () => {
    if (busy) return;
    setBusy(true);
    try { setStatus((await enableWebPush()).status); }
    catch { setStatus("error"); }
    finally { setBusy(false); }
  };
  return <button type="button" onClick={enable} disabled={busy} className="pc-card mb-3 flex w-full items-center gap-3 p-4 text-left" style={{ borderColor: "rgba(0,229,255,.38)", background: "linear-gradient(110deg, var(--pc-cyan-dim), var(--pc-charcoal))" }} data-testid="player-push-opt-in">
    <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl" style={{ background: "var(--pc-card-inset)", color: "var(--pc-cyan)" }}><BellRing size={18} /></span>
    <span className="min-w-0 flex-1"><strong className="block text-sm">{t("pushOptInTitle")}</strong><span className="mt-1 block text-sm leading-snug" style={{ color: "var(--pc-muted)" }}>{t("pushOptInBody")}</span><span className="mt-2 block text-xs font-semibold" style={{ color: "var(--pc-cyan)" }}>{busy ? t("loading") : t("pushEnable")}</span></span>
    <ChevronRight size={16} className="shrink-0" color="var(--pc-muted)" />
  </button>;
}
